import { Outlet } from 'react-router-dom';
import { CleanLayout } from './components/CleanLayout';

export const CleanPublicWrapper = () => (
  <CleanLayout>
    <Outlet />
  </CleanLayout>
);
